import { render } from "./UserImport.vue?vue&type=template&id=2c6a72ba"
import script from "./UserImport.vue?vue&type=script&lang=js"
export * from "./UserImport.vue?vue&type=script&lang=js"

import "./UserImport.vue?vue&type=style&index=0&id=2c6a72ba&lang=css"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__